import React, {FC, useMemo} from 'react';
import {DISPLAY, View} from '@lookiero/aurora';
import {ConfigurationApplication} from '@application/Config';
import {Image} from './Image';
import {Animation} from './Animation';
import {TradeName} from '@domain/model/Config/Configuration';

export const MediaSection: FC = () => {
  const tradename = ConfigurationApplication.retrieve().tradename;

  const Media = useMemo(() => {
    if (tradename === TradeName.OUTFITTERY) return Image;
    if (tradename === TradeName.LOOKIERO) return Animation;

    return React.Fragment;
  }, [tradename]);

  return (
    <View style={{flex: 1}} display={DISPLAY.FLEX}>
      <Media />
    </View>
  );
};
